import UiLib from '@ai/ui-components'
import type { PropsOf } from '@/types/typeUtils'

type UiIconProps = PropsOf<(typeof UiLib)['UiIcon']>

/**
 * Icons config for direct row action buttons.
 * PRIMARY source of truth for all the action icons
 * `ActionButton.vue` resolves its `icon` prop through this map.
 */
export const ACTION_BUTTON_ICONS = {
  edit: 'pen',
  duplicate: 'copy',
  preview: 'eye',
  import: 'reopen-issue',
  download: 'download',
  liveTest: 'artificial-intelligence',
  export: 'download',
  phone: 'phone',
  unassign: 'link',
  delete: 'delete',
  listen: 'audio-on',
  details: 'eye',
  copyLink: 'link',
  report: 'alert',
} as const satisfies Record<string, UiIconProps['name']>
